import { queryWorkerList, addWorker, editWorker } from '../requests';

const initPagination = {
  pageSize: 10,
  currentPage: 1,
  total: 0,
};

const Model = {
  namespace: 'workerManagement',
  state: {
    tabledData: [],
    pagination: initPagination,
  },
  effects: {
    *queryWorkerList({ payload }, { call, put }) {
      const res = yield call(queryWorkerList, payload);
      if (res && res.code === 0) {
        yield put({
          type: 'saveWorkerList',
          payload: res.data,
        });
      }
    },
    *addWorker({ payload }, { call }) {
      return yield call(addWorker, payload);
    },
    *editWorker({ payload }, { call }) {
      return yield call(editWorker, payload);
    },
  },
  reducers: {
    saveWorkerList(state, { payload }) {
      const { pageNum, pageSize, total, dataInfos } = payload;
      const pagination = {
        currentPage: pageNum,
        pageSize,
        total,
      };
      return { ...state, tabledData: dataInfos, pagination };
    },
  },
};
export default Model;
